import PropTypes from 'prop-types'
import styled from 'styled-components'
import { space, layout, fontSize } from 'styled-system'
import { lighten } from 'polished'
import { COLORS } from 'config/constants'
import { theme, radius } from 'config/theme'
import { pxToRem } from 'utils/helpers'

const getShadow = (shadowColor, isVisible) =>
  shadowColor &&
  isVisible &&
  `box-shadow: 0 ${pxToRem(14)} ${pxToRem(20)} -${pxToRem(12)} ${shadowColor};`

const buttonFuncs = [space, layout, fontSize]

const ButtonBase = styled.button`
  padding: 1em 2em 0.9em;
  border: none;
  border-radius: ${radius.m};
  cursor: pointer;
  min-width: ${theme.space.xxl};
  background-color: ${COLORS.WHITE};
  line-height: 1;
  vertical-align: middle;
  text-align: center;
  font-weight: ${theme.fontWeights.bold};
  text-decoration: none;
  :focus {
    outline: 0;
  }
`

const Outlined = styled(ButtonBase)`
  ${({ color, borderColor, isShadow }) => `
    box-shadow: 0 0 0 1.5px ${lighten(0.1, borderColor)};
    color: ${color};
    ${getShadow(color, isShadow)}}
  `}
  ${({ isTransparent }) => isTransparent && `background-color: transparent;`}
  ${buttonFuncs}
`

Outlined.propTypes = {
  color: PropTypes.string,
  borderColor: PropTypes.string,
  isShadow: PropTypes.bool,
  isTransparent: PropTypes.bool,
}

Outlined.defaultProps = {
  borderColor: theme.colors.brandCta,
  color: theme.colors.brandCta,
}

const Filled = styled(ButtonBase)`
  padding-left: ${theme.space.l};
  padding-right: ${theme.space.l};
  color: ${({ color }) => color || COLORS.WHITE};
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: ${({ gradientFromColor, gradientToColor }) =>
    `linear-gradient(90deg, ${gradientFromColor}, ${gradientToColor})`};
  ${({ gradientFromColor, isShadow }) => getShadow(gradientFromColor, isShadow)}
  ${buttonFuncs};
  transition: background-color 0.5s;
  :hover {
    background-color: ${COLORS.BUTTERSCOTCH};
  }
`

Filled.propTypes = {
  isShadow: PropTypes.bool,
  color: PropTypes.string,
  gradientFromColor: PropTypes.string,
  gradientToColor: PropTypes.string,
}

Filled.defaultProps = {
  backgroundColor: theme.colors.brandCta,
  gradientFromColor: COLORS.PERICALLIS_HYBRIDA,
  gradientToColor: COLORS.ULTRA_PINK,
}

export default {
  Outlined,
  Filled,
}
